import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import AdminLogin from './pages/AdminLogin';
import ChangePassword from './pages/ChangePassword';
import PowerUserDashboard from './pages/PowerUserDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ManagerDashboard from './pages/ManagerDashboard';
import SiteDashboard from './pages/SiteDashboard';
import VersionWatermark from './components/VersionWatermark';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <VersionWatermark />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/power-user" element={<PowerUserDashboard />} />
            <Route
              path="/admin"
              element={
                <PrivateRoute requiredRole={['power_user', 'admin']}>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/manager"
              element={
                <PrivateRoute requiredRole={['power_user', 'admin', 'manager']}>
                  <ManagerDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/site"
              element={
                <PrivateRoute requiredRole="site">
                  <SiteDashboard />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

